import {
  GET_ACT_SHIPPING,
  GET_ACT_SHIPPING_SUCCESS,
  GET_ACT_SHIPPING_FAIL,
  ADD_ACT_SHIPPING,
  ADD_ACT_SHIPPING_SUCCESS,
  ADD_ACT_SHIPPING_FAIL,
  UPDATE_ACT_SHIPPING,
  UPDATE_ACT_SHIPPING_SUCCESS,
  UPDATE_ACT_SHIPPING_FAIL,
  DELETE_ACT_SHIPPING,
  DELETE_ACT_SHIPPING_SUCCESS,
  DELETE_ACT_SHIPPING_FAIL,
  SHOW_LOADING,
  HIDE_LOADING
} from './actionTypes';

// GET ALL ACTIVIDANS
export const getActShippings = () => ({
  type: GET_ACT_SHIPPING
});
export const getActShippingsSuccess = (ACT_SHIPPINGs) => ({
  type: GET_ACT_SHIPPING_SUCCESS,
  payload: ACT_SHIPPINGs
});
export const getActShippingsFail = (error) => ({
  type: GET_ACT_SHIPPING_FAIL,
  payload: error
});
// ADD NEW LOST ORDER
export const addActShipping = (ACT_SHIPPING) => ({
  type: ADD_ACT_SHIPPING,
  payload: ACT_SHIPPING
});
export const addActShippingSuccess = (ACT_SHIPPING) => ({
  type: ADD_ACT_SHIPPING_SUCCESS,
  payload: ACT_SHIPPING
});
export const addActShippingFail = (error) => ({
  type: ADD_ACT_SHIPPING_FAIL,
  payload: error
});
// UPDATE LOST ORDER
export const updateActShipping = (ACT_SHIPPING) => ({
  type: UPDATE_ACT_SHIPPING,
  payload: ACT_SHIPPING
});
export const updateActShippingSuccess = (ACT_SHIPPING) => ({
  type: UPDATE_ACT_SHIPPING_SUCCESS,
  payload: ACT_SHIPPING
});
export const updateActShippingFail = (error) => ({
  type: UPDATE_ACT_SHIPPING_FAIL,
  payload: error
});
// DELETE LOST ORDER
export const deleteActShipping = (ACT_SHIPPING) => ({
  type: DELETE_ACT_SHIPPING,
  payload: ACT_SHIPPING
});
export const deleteActShippingSuccess = (ACT_SHIPPING) => ({
  type: DELETE_ACT_SHIPPING_SUCCESS,
  payload: ACT_SHIPPING
});
export const deleteActShippingFail = (error) => ({
  type: DELETE_ACT_SHIPPING_FAIL,
  payload: error
});
// DISPLAY LOADING ICON
export const showLoading = (status) => ({
  type: SHOW_LOADING,
  payload: status
});
export const hideLoading = (status) => ({
  type: HIDE_LOADING,
  payload: status
});
